import LegalPolicyPage from './LegalPolicyPage';
export default function ReschedulingCancellationPolicy() {
  return <LegalPolicyPage slug="rescheduling-cancellation-policy" fallbackTitle="Rescheduling & Cancellation Policy" />;
}
